function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "three-bullet",
  transform: "translate(-736 -761)",
  opacity: 0.7
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_142",
  "data-name": "Ellipse 142",
  cx: 5.5,
  cy: 5.5,
  r: 5.5,
  transform: "translate(736 761)",
  fill: "#838383"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_143",
  "data-name": "Ellipse 143",
  cx: 5.5,
  cy: 5.5,
  r: 5.5,
  transform: "translate(755 761)",
  fill: "#838383"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_144",
  "data-name": "Ellipse 144",
  cx: 5.5,
  cy: 5.5,
  r: 5.5,
  transform: "translate(773 761)",
  fill: "#838383"
}));

function SvgThreeBullet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 11,
    viewBox: "0 0 48 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeBullet);
export default __webpack_public_path__ + "static/media/three-bullet.0a9f74ad.svg";
export { ForwardRef as ReactComponent };